import { render, staticRenderFns } from "./PatientRoutineView.vue?vue&type=template&id=57981c9c"
import script from "./PatientRoutineView.vue?vue&type=script&lang=js"
export * from "./PatientRoutineView.vue?vue&type=script&lang=js"
import style0 from "./PatientRoutineView.vue?vue&type=style&index=0&id=57981c9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports